import { FunctionComponent, useState } from 'react';

import Box from '../../Layout/Box/Box';
import Icon from '../../DataDisplay/Icon/Icon';
import SubTitle from '../../Text/SubTitle/SubTitle';
import Title from '../../Text/Title/Title';

import Widget, { WidgetData, WidgetName } from '../../DataDisplay/Widget/Widget';

import styles from './WidgetDisplay.module.scss';

export type WidgetProps = {
  name: WidgetName;
  data: WidgetData;
};

export type WidgetDisplayProps = {
  title: string;
  widgetList: WidgetProps[];
};

type FC = FunctionComponent<WidgetDisplayProps>;

const WidgetDisplay: FC = ({ title, widgetList = [] }: WidgetDisplayProps) => {
  const [selectedIdx, setSelectedIdx] = useState(0);
  const [showDetails, setShowDetails] = useState(false);

  const handlePreviewClick = (idx: number) => {
    setSelectedIdx(idx);
  };

  const handleIconClick = () => {
    setShowDetails(!showDetails);
  };

  return (
    <Box flx="col" mt="lg">
      <Title title={title} />
      <Box jc="sb" mb="md">
        <SubTitle subTitle="Data at a glance or toggle the button to the right for details." />

        <div id="toggle-showDetails" className={styles.iconButton} onClick={handleIconClick} role="button" aria-hidden>
          <Icon icon={showDetails ? 'gridSquares' : 'gridSquaresAdd'} />
        </div>
      </Box>
      <Box mb="md">
        <div className={styles.hero}>
          <Widget
            key={`widget-hero-${widgetList[selectedIdx].name}`}
            {...widgetList[selectedIdx]}
            showDetails={showDetails}
            height={300}
            mode="hero"
          />
        </div>
      </Box>
      <Box mb="md">
        <SubTitle subTitle="Examine your recent data by selecting any of the preview cards below." />
      </Box>
      <div className={styles.previewContainer}>
        {widgetList.map((props, idx) => {
          const { name } = props;

          return (
            <div key={`${name}-${idx}`} className={[styles.preview, styles[getSelectedClass(idx)]].join(' ')}>
              <Widget
                key={`widget-preview-${name}`}
                {...props}
                id={idx}
                onClick={handlePreviewClick}
                labelSize="sm"
                height={200}
                mode="preview"
              />
            </div>
          );
        })}
      </div>
    </Box>
  );

  function getSelectedClass(idx: number) {
    return idx === selectedIdx ? 'selected' : '';
  }
};

export default WidgetDisplay;
